export default {
  TITLE: "Tito - Epidemi-Mobilen",
  LOGO: "./assets/images/logo-en-us.png",
  TAB: "Tito and the birds",
  SUBTITLE: "Epidemi-mobilen",
  DOWNLOAD_TITLE: "Lärare och pedagoger",
  DOWNLOAD_TEXT: "Ladda ned materialet för att spela spelet på er skola",
  DOWNLOAD_BUTTON: "Ladda Ned",
  PLAY_TEXT:
    "Följ med Tito och hans vänner på deras uppdrag att rädda världen från rädsla-viruset.",
  PDF_LINK: "./tito-material-didatico-sv-se.pdf",
  VIDEO_LINK: "https://www.youtube.com/watch?v=s0MQOjPk_9c&feature=youtu.be",
  TITO_LINK: "http://titoeospassaros.com.br/",
  SITE_URL: "http://titoandthebirds.com/game/#/sv-se",
  SITE_DESCRIPTION:
    "Lärare, barn, föräldrar och lärare - Lär dig att bekämpa falska nyheter med Tito och fåglarna",
  COPYRIGHT: `Tito - Epidemi-Mobilen by <a href="http://pushstart.com.br/" target="_blank" rel="noopener noreferrer"
  >PushStart</a>. © 2019 Bits Filmes. Alla rättigheter reserverade`,
  PIXEL_CONVERSION_PTBR:
    "https://secure.adnxs.com/px?id=1087807&seg=17258326&t=2"
};



// WEBPACK FOOTER //
// ./src/utils/locales/sv-SE.js